import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { GuideModal } from './GuideModal';
import { Sparkle } from './Sparkle';
import { CalendlyModal } from './CalendlyModal';

/**
 * Abschluss-Sektion mit zwei klaren nächsten Schritten:
 * kostenlosen Guide sichern oder ein Kennenlerngespräch buchen.
 */
export function NextStep() {
  const [guideOpen, setGuideOpen] = useState(false);
  const [calendlyOpen, setCalendlyOpen] = useState(false);
  return <section id="guide" className="relative w-full bg-cream px-4 py-10 sm:px-6 sm:py-12" data-id="element-329" data-mp="30r5gas9idonk">
      <span aria-hidden="true" className="gold-glitter-layer-static" data-id="element-330" data-mp="34sh8n5jronzg" />
      <span aria-hidden="true" className="gold-glitter-extra" data-id="element-331" data-mp="2qy6t9etnu662" />

      <div className="relative z-10 mx-auto max-w-[1100px]" data-id="element-332" data-mp="2vxjddrt5cz4y">
        <div className="text-center" data-id="element-333" data-mp="2vvyh9xr6p84z">
          <span className="mb-4 block text-xs font-semibold uppercase tracking-[0.25em] text-neutral-700" data-id="element-334" data-mp="3jn3wcapavwe8">
            So geht’s weiter
          </span>
          <div className="relative inline-block" data-id="element-335" data-mp="3ofos3hrrojke">
            <Sparkle className="animate-sparkle -left-6 top-1 h-5 w-5 sm:-left-9 sm:h-7 sm:w-7" data-id="element-336" data-mp="1zvurihjt91dk" />
            <Sparkle className="animate-sparkle-fast -right-5 bottom-1 h-4 w-4 sm:-right-8 sm:h-5 sm:w-5" data-id="element-337" data-mp="1vvkjz0gde2wl" />
            <h2 className="font-display text-2xl font-extrabold uppercase leading-[1.15] text-hot-500 sm:text-3xl lg:text-4xl" data-id="element-338" data-mp="29mphnx06gl4a">
              Dein nächster Schritt
            </h2>
          </div>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-neutral-700" data-id="element-339" data-mp="2jju29sedk8iz">
            Hol dir den kostenlosen Guide und erfahre in Ruhe, wie dein Einstieg als
            Premium-Closerin aussehen kann – oder buch dir direkt ein kostenloses und
            unverbindliches Gespräch. Gemeinsam schauen wir, wo du aktuell stehst und wie wir dich
            auf deinem Weg zur Premium-Closerin begleiten können.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 sm:gap-6" data-id="element-340" data-mp="y93qk6arc9g4">
          <motion.button type="button" onClick={() => setGuideOpen(true)} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.45,
          delay: 0.1
        }} className="group flex min-h-[330px] flex-col justify-end rounded-2xl bg-gradient-to-b from-hot-50 to-[#eeb4d0] p-4 text-left shadow-xl min-[390px]:max-sm:justify-start min-[390px]:max-sm:pt-14 max-[389px]:justify-start md:max-lg:justify-start transition-transform duration-200 ease-out hover:-translate-y-1 sm:min-h-[380px] sm:rounded-[2rem] sm:p-10" data-id="element-341" data-mp="t9hazq7gih45">
            <span className="text-[9px] font-semibold uppercase tracking-[0.2em] text-hot-600 sm:text-xs sm:tracking-[0.25em]" data-id="element-342" data-mp="3lyun9b23ojv6">
              Hol dir den
            </span>
            <span className="font-heading mt-2 block text-xl font-bold leading-tight text-neutral-900 sm:mt-3 sm:text-4xl" data-id="element-343" data-mp="3uzsppoww4jbn">
              Kostenlosen Guide
            </span>
            <span className="mb-[1.625em] mt-2 block text-[11px] leading-relaxed text-neutral-700 max-[389px]:mb-0 min-[390px]:max-sm:mb-0 sm:mb-0 sm:mt-4 sm:text-sm" data-id="element-344" data-mp="3rez19un3rg4">
              Dein 15-seitiger Guide für deinen Einstieg in High Ticket Sales: Erfahre, wie du als
              Premium-Closerin ortsunabhängig arbeiten und dir Schritt für Schritt ein attraktives
              Einkommen aufbauen kannst.
            </span>
            <span className="btn-gold-shiny mt-4 inline-flex items-center justify-center rounded-full px-3 py-2 text-center text-[11px] font-semibold leading-tight min-[390px]:max-sm:mt-auto sm:mt-8 sm:w-fit sm:px-6 sm:py-2.5 sm:text-sm max-[389px]:mt-auto md:max-lg:mt-auto" data-id="element-345" data-mp="271s1ymo2pdwa">
              Guide kostenlos sichern
            </span>
          </motion.button>

          <motion.button type="button" onClick={() => setCalendlyOpen(true)} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.45,
          delay: 0.2
        }} className="group flex min-h-[330px] flex-col justify-end rounded-2xl bg-gradient-to-b from-cream to-gold/50 p-4 text-left shadow-xl min-[390px]:max-sm:justify-start min-[390px]:max-sm:pt-14 max-[389px]:justify-start md:max-lg:justify-start transition-transform duration-200 ease-out hover:-translate-y-1 sm:min-h-[380px] sm:rounded-[2rem] sm:p-10" data-id="element-346" data-mp="1tad5pe55ng7a">
            <span className="text-[9px] font-semibold uppercase tracking-[0.2em] text-gold-dark sm:text-xs sm:tracking-[0.25em]" data-id="element-347" data-mp="2p924td6mwu9r">
              Buch
            </span>
            <span className="font-heading mt-2 block text-xl font-bold leading-tight text-neutral-900 sm:mt-3 sm:text-4xl" data-id="element-348" data-mp="2fi7kiecy84qy">
              Deinen Termin
            </span>
            <span className="mt-2 block text-[11px] leading-relaxed text-neutral-700 sm:mt-4 sm:text-sm" data-id="element-349" data-mp="2kepjexlll8vd">
              Lern uns in einem kostenlosen und unverbindlichen Gespräch kennen. Gemeinsam schauen
              wir, wo du aktuell stehst und wie dein persönlicher Weg in High Ticket Sales aussehen
              kann.
            </span>
            <span className="btn-gold-shiny mt-4 inline-flex items-center justify-center rounded-full px-3 py-2 text-center text-[11px] font-semibold leading-tight min-[390px]:max-sm:mt-auto sm:mt-8 sm:w-fit sm:px-6 sm:py-2.5 sm:text-sm max-[389px]:mt-auto md:max-lg:mt-auto" data-id="element-350" data-mp="3ibd0b3fqzl4x">
              Kostenloses Gespräch buchen
            </span>
          </motion.button>
        </div>
      </div>

      <GuideModal open={guideOpen} onClose={() => setGuideOpen(false)} data-id="element-351" data-mp="2zc7ey173ytjt" />
      <CalendlyModal open={calendlyOpen} onClose={() => setCalendlyOpen(false)} data-id="element-352" data-mp="2ze1z3dak2hmu" />
    </section>;
}